import React from 'react';
import MaskedInput from 'react-text-mask';
import { StyledTextbox } from '@nib-components/textbox';
import BaseFormField from '../base-form-field';
import { AddFunnelPropFromContext } from '../funnel-context';
import { FUNNELS, LABELS as DEFAULT_LABELS } from '../../util/constants';
import { defaultFieldPropTypes } from '../../types';
const LABELS = {
  ARHI: DEFAULT_LABELS.MEDICARE_NUMBER
};
const mask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]; // Up to 11 digits
const MedicareNumber = props => {
  const {
    funnel = FUNNELS.ARHI,
    help = 'We need your Medicare number for the Australian Government Rebate and for claiming.',
    width = 20,
    optional = false,
    required
  } = props;
  return React.createElement(BaseFormField, {
    ...props,
    label: props.label || LABELS[funnel] || LABELS.ARHI,
    funnel: funnel,
    width: width,
    help: help,
    optional: optional,
    required: required
  }, React.createElement(MaskedInput, {
    guide: false,
    mask: mask,
    ...props.field,
    render: (ref, props) => React.createElement(StyledTextbox, {
      ref: ref,
      ...props
    })
  }));
};
MedicareNumber.defaultProps = {
  ...defaultFieldPropTypes,
  help: 'We need your Medicare number for the Australian Government Rebate and for claiming.'
};
const MedicareNumberWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(MedicareNumber, {
  ...props
}));
export default MedicareNumberWithFunnel;